import { DataDropdown } from "capitalrx-components-2.0/lib/forms";

import { getApiBaseUrl } from "@/api";
import { FormElementBaseProps } from "@/api/interfaces";
import { useCallback } from "react";
import { MedicalBenefitServiceCategoryResult } from "capitalrx-types";
import { FilterSet, useRemoteTableDataSource } from "capitalrx-components-2.0/lib/general";


interface ServiceCategoryDropdownProps extends FormElementBaseProps {
  plan_id: string;
  external_member_id?: string;
  person_code?: string;
  member_id?: string;
}

export const ServiceCategoryDropdown = ({
  name = "service_category",
  label = "Service Category",
  required = false,
  disabled = false,
  plan_id,
  external_member_id,
  person_code,
  member_id,
}: ServiceCategoryDropdownProps) => {
  const serviceCategoryLabels = useCallback((row: MedicalBenefitServiceCategoryResult) => {
    const serviceCategoryName = row.service_category?.service_category;
    return `${serviceCategoryName}`;
  }, []);

  const dataSource = useRemoteTableDataSource<MedicalBenefitServiceCategoryResult>(
    `${getApiBaseUrl()}/service_category/list_max_names`,
    (row) => row?.service_category?.service_category,
    {
      idFilterName: "service_category",
      filter: {
        plan_id: plan_id,
        external_member_id: external_member_id,
        person_code: person_code,
        member_id: member_id,
      },
      pageSize: 15,
      sort: [{ name: "service_category", direction: "ascending" }],
      enabled: (filters: FilterSet) => !!filters.plan_id,
    },
  );

  return (
    <DataDropdown.Field
      dataSource={dataSource}
      optionLabelProvider={serviceCategoryLabels}
      label={label}
      key={name}
      name={name}
      required={required}
      disabled={disabled}
      searchField="name"
    />
  );
};
